import { createAction } from '@reduxjs/toolkit';

export const exportInputValuesModalOpen = createAction<{
  exportTargetIds: string[];
  exportTargetResource: 'DOCUMENTS' | 'BULK_REQUEST' | 'CONTRACT_LINK' | 'LABEL';
}>('exportInputValues/requesterMethodsRequestModalOpen');

export const exportInputValuesModalClose = createAction('exportInputValues/requestModalClose');
export const exportInputValuesCompletedModalClose = createAction(
  'exportInputValues/completedModalClose'
);
export const exportInputValuesFailureModalClose = createAction(
  'exportInputValues/FailureModalClose'
);
export const exportInputValuesProgressModalClose = createAction(
  'exportInputValues/ProgressModalClose'
);
export const exportInputValuesStart = createAction<{ jobId: string }>('exportInputValues/start');
export const exportInputValuesInitialize = createAction('exportInputValues/initialize');

interface ExportInputValuesPayload {
  failureCount: number;
  successCount: number;
  totalCount: number;
  url: string | null;
}
interface ExportInputValuesFailurePayload extends ExportInputValuesPayload {
  errorMessage: string;
}

export const exportInputValuesSuccess = createAction<ExportInputValuesPayload>(
  'exportInputValues/success'
);

export const exportInputValuesFailure = createAction<ExportInputValuesFailurePayload>(
  'exportInputValues/failure'
);

export const exportInputValuesModalMinimize = createAction<{ isMinimized: boolean }>(
  'exportInputValues/minimize'
);
